const Loader = () => {
  return (
    <div className="flex items-center justify-center w-full h-full">
      <div className="w-12 h-12 border-4 border-Indigo border-b-transparent rounded-[50%] animate-spin"></div>
    </div>
  );
};

export default Loader;
